import { render, staticRenderFns } from "./academic_referee_system.vue?vue&type=template&id=671d6a66&scoped=true&"
import script from "./academic_referee_system.vue?vue&type=script&lang=js&"
export * from "./academic_referee_system.vue?vue&type=script&lang=js&"
import style0 from "./academic_referee_system.vue?vue&type=style&index=0&id=671d6a66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d6a66",
  null
  
)

export default component.exports